<template>
    <div class="data-card-top">
        <div class="top-title">{{ title }}</div>
        <div class="data-card-top-value flex-row">
            <div class="card-top-item flex-row">
                {{ $t('wuliu.workbench.dailyAvg') }}
                <div class="card-top-val">
                    {{ prefix }} {{ dayNum }} {{ suffix }}
                </div>
            </div>
            <div class="card-top-item flex-row">
                {{ $t('wuliu.workbench.total') }}
                <div class="card-top-val">
                    {{ prefix }} {{ totalNum }} {{ suffix }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChartHeader',
    props: {
        title: {
            type: String,
            required: true,
        },
        dayNum: {
            type: Number,
            default: 0,
        },
        totalNum: {
            type: Number,
            default: 0,
        },
        prefix: { // 数值前缀（如￥）
            type: String,
            default: '',
        },
        suffix: { // 数值后缀（如人、单）
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" scoped>
.data-card-top {
    font-size: 16px;
    // font-weight: bold;
    margin-bottom: 10px;
    height: 60px;

    .top-title {
        // font-weight: bold;
    }

    .data-card-top-value {
        margin-top: 10px;
        height: 30px;
        line-height: 30px;
        text-align: center;

        .card-top-item {
            flex: 1;
            margin-right: 10px;
            background-color: #1A47A4;
            padding: 0 16px;

            &:last-child {
                margin-right: 0;
            }

            .card-top-val {
                color: #34C6D0;
                margin-left: 8px;
                font-size: 18px;
                // font-weight: bold;
            }
        }
    }
}

.flex-row {
    display: flex;
}
</style>
